// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SingleSimilarEbooks_container__XGmGm {
    width: 100%;
  }
  .SingleSimilarEbooks_similarBooks__Ws\\+PL {
    width: 95%;
    max-width: 1400px;
    position: relative;
    margin: auto;
  }
  
  .SingleSimilarEbooks_similarBooksTitle__zJzkb {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    color: white;
  }
  
  .SingleSimilarEbooks_swiper__aaPsY {
    width: 100%;
    height: 100%;
    padding-bottom: 4rem;
  }
  
  .SingleSimilarEbooks_swiperSlide__2Mwss {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .SingleSimilarEbooks_bookCard__KEgn0 {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
    transition: transform 0.3s ease;
  }
  
  .SingleSimilarEbooks_bookCard__KEgn0:hover {
    transform: scale(1.05);
  }
  
  .SingleSimilarEbooks_bookCover__kw7q3 {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
  }
  
  /* Custom navigation styles */
  .swiper-button-next,
  .swiper-button-prev {
    color: #333;
    background-color: rgba(255, 255, 255, 0.8);
    width: 35px;
    height: 35px;
    border-radius: 50%;
  }
  
  .swiper-button-next:after,
  .swiper-button-prev:after {
    font-size: 16px;
    font-weight: bold;
  }
  
  .swiper-button-next:hover,
  .swiper-button-prev:hover {
    background-color: rgba(255, 255, 255, 0.95);
  }
  
  /* Hide navigation on mobile */
  @media (max-width: 768px) {
    .swiper-button-next,
    .swiper-button-prev {
      display: none;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/reading-pages/shortStories/SingleSimilarEbooks.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;EACb;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;;EAEA,6BAA6B;EAC7B;;IAEE,WAAW;IACX,0CAA0C;IAC1C,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,2CAA2C;EAC7C;;EAEA,8BAA8B;EAC9B;IACE;;MAEE,aAAa;IACf;EACF","sourcesContent":[".container {\n    width: 100%;\n  }\n  .similarBooks {\n    width: 95%;\n    max-width: 1400px;\n    position: relative;\n    margin: auto;\n  }\n  \n  .similarBooksTitle {\n    font-size: 20px;\n    font-weight: bold;\n    margin-bottom: 20px;\n    color: white;\n  }\n  \n  .swiper {\n    width: 100%;\n    height: 100%;\n    padding-bottom: 4rem;\n  }\n  \n  .swiperSlide {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .bookCard {\n    width: 100%;\n    height: 100%;\n    border-radius: 8px;\n    overflow: hidden;\n    transition: transform 0.3s ease;\n  }\n  \n  .bookCard:hover {\n    transform: scale(1.05);\n  }\n  \n  .bookCover {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    cursor: pointer;\n  }\n  \n  /* Custom navigation styles */\n  :global(.swiper-button-next),\n  :global(.swiper-button-prev) {\n    color: #333;\n    background-color: rgba(255, 255, 255, 0.8);\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n  }\n  \n  :global(.swiper-button-next:after),\n  :global(.swiper-button-prev:after) {\n    font-size: 16px;\n    font-weight: bold;\n  }\n  \n  :global(.swiper-button-next:hover),\n  :global(.swiper-button-prev:hover) {\n    background-color: rgba(255, 255, 255, 0.95);\n  }\n  \n  /* Hide navigation on mobile */\n  @media (max-width: 768px) {\n    :global(.swiper-button-next),\n    :global(.swiper-button-prev) {\n      display: none;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SingleSimilarEbooks_container__XGmGm`,
	"similarBooks": `SingleSimilarEbooks_similarBooks__Ws+PL`,
	"similarBooksTitle": `SingleSimilarEbooks_similarBooksTitle__zJzkb`,
	"swiper": `SingleSimilarEbooks_swiper__aaPsY`,
	"swiperSlide": `SingleSimilarEbooks_swiperSlide__2Mwss`,
	"bookCard": `SingleSimilarEbooks_bookCard__KEgn0`,
	"bookCover": `SingleSimilarEbooks_bookCover__kw7q3`
};
export default ___CSS_LOADER_EXPORT___;
